import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReferenceDataLabels } from '../../../../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../../../../lib/constants/reference-data-option-lists';
import { ApplicationProductRepaymentMethod } from './../../../models/application-product-repayment-method.model';

@Component({
  selector: 'boi-product-repayment-methods',
  templateUrl: './product-repayment-methods.component.html',
  styleUrls: ['./product-repayment-methods.component.scss']
})
export class ProductRepaymentMethodsComponent implements OnInit {
  referenceDataLabels = ReferenceDataLabels;
  @Input() isMortgageApplicationFactFind: boolean;
  @Input() isPartAndPart: boolean;
  @Input() isMortgageApplicationBtl: boolean;
  @Input() data: Array<ApplicationProductRepaymentMethod>;
  @Output() readonly dataChange = new EventEmitter<Array<ApplicationProductRepaymentMethod>>();
  @Input() public isFieldDisabled: boolean;

  public exclusiveOptionCode = ReferenceDataOptionLists.RepaymentMethodBtlSaleOfThisProperty;
  public isExclusiveOptionSelected: boolean;
  public labelName: string;

  public ngOnInit(): void {
    this.isExclusiveOptionSelected = this.hasElementSelected(this.exclusiveOptionCode);
    this.labelName = this.isPartAndPart
      ? this.isMortgageApplicationFactFind
        ? ReferenceDataLabels.RepaymentMethodInterestOnlyFF
        : ReferenceDataLabels.RepaymentMethodInterestOnly
      : this.isMortgageApplicationFactFind
      ? ReferenceDataLabels.RepaymentMethodLoanFF
      : ReferenceDataLabels.RepaymentMethodLoan;
  }

  public getRepaymentMethodCodes(): string {
    return this.isMortgageApplicationBtl
      ? ReferenceDataOptionLists.RepaymentMethodBtl
      : ReferenceDataOptionLists.RepaymentMethodResidential;
  }

  public hasElementSelected(code): boolean {
    return this.data && this.data.find((method) => method.RepaymentMethodCode === code) !== undefined;
  }

  public onRepaymentMethodChange($event): void {
    if (!$event) {
      return;
    }

    if ($event === this.exclusiveOptionCode) {
      this.proccessExclusiveOption();
    }

    this.proccessCheckboxOptions($event);

    this.dataChange.emit(this.data);
  }

  private proccessExclusiveOption(): void {
    if (this.isExclusiveOptionSelected) {
      this.isExclusiveOptionSelected = false;
    } else {
      this.isExclusiveOptionSelected = true;
      this.data.splice(0, this.data.length);
    }
  }

  private proccessCheckboxOptions(selectedRepaymentMethod: string): void {
    if (this.data.find((method) => method.RepaymentMethodCode === selectedRepaymentMethod) === undefined) {
      const newMethod = new ApplicationProductRepaymentMethod();
      newMethod.RepaymentMethodCode = selectedRepaymentMethod;
      this.data.push(newMethod);
    } else {
      this.data = this.data.filter((method) => method.RepaymentMethodCode !== selectedRepaymentMethod);
    }
  }
}
